module.exports = {
  DEPARTMENT: 'DEPARTMENT',
  GROUP: 'GROUP',
};
